import classNames from 'classnames';
import React from 'react';
import styles from './controls-header.scss';

interface Props {
  title: string;
  children: any;
  withoutDivider?: boolean;
}

export class ControlsHeader extends React.Component<Props> {
  public static defaultProps = {
    withoutDivider: false,
  };

  public render() {
    const { title, withoutDivider, children } = this.props;

    const headerClasses = classNames({
      [styles.headerOnlyTitle]: true,
      [styles.withDivider]: !withoutDivider,
    });

    return (
      <div className={headerClasses}>
        <div>
          <div data-hook="title" className={styles.title}>
            {title}
          </div>
        </div>
        <div className={styles.controls}>{children}</div>
      </div>
    );
  }
}
